// import React, { useState, useEffect } from "react";
// import PhoneInput from "react-phone-input-2";
// import 'react-phone-input-2/lib/style.css';
// import { Input, FormFeedback, Tooltip } from "reactstrap";

// const PhoneNumberInput = ({
//     label = "Phone Number",
//     placeholder = "Enter your phone number",
//     required = false,
//     layout = "below",
//     name = "phone",
//     value = "",
//     id = "phoneNumberInput",
//     validateTrigger = false,
//     onChange = () => {},
//     onBlur = () => {},
//     requiredErrorMessage = "This field is required.",
//     validationErrorMessage = "Please enter a valid phone number.",
//     showHelp = false,
//     helpText = "Please enter your phone number, including country code.",
//     showFlags = true,
// }) => {
//     const [inputValue, setInputValue] = useState(value);
//     const [errors, setErrors] = useState({});
//     const [tooltipOpen, setTooltipOpen] = useState(false);
//     useEffect(() => {
//         setInputValue(value); // Update inputValue when the value prop changes
//     }, [value]);
//     useEffect(() => {
//         if (validateTrigger) {
//             validateInput(inputValue);
//         }
//     }, [validateTrigger]);

//     const validateInput = (value) => {
//         const newErrors = {};
//         const numericValue = value.replace(/\D/g, "");

//         if (required && !value) {
//             newErrors.required = requiredErrorMessage;
//         } else if (!showFlags && numericValue.length !== 10) {
//             newErrors.validation = "Phone number must be exactly 10 digits.";
//         } else if (showFlags && numericValue.length < 10) {
//             newErrors.validation = validationErrorMessage;
//         }

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleInputChange = (value) => {
//         setInputValue(value);
//         validateInput(value);
//         onChange(value);
//     };

//     const handleInputBlur = () => {
//         validateInput(inputValue);
//         onBlur();
//     };

//     return (
//         <div className={layout === "inline" ? "d-flex align-items-center" : ""} style={{ marginBottom: '1rem' }}>
//             <label htmlFor={id} className="d-flex align-items-center" style={{ width: layout === "inline" ? "20%" : "100%" }}>
//                 {label}
//                 {required && <span className="text-danger mx-1">*</span>}
//                 {showHelp && (
//                     <span id="helpTooltip" className="px-2" style={{ cursor: 'pointer' }}>
//                         <i className="ri-question-line" style={{ fontSize: '16px' }} />
//                     </span>
//                 )}
//             </label>
//             {showHelp && (
//                 <Tooltip
//                     placement="right"
//                     isOpen={tooltipOpen}
//                     target="helpTooltip"
//                     toggle={() => setTooltipOpen(!tooltipOpen)}
//                 >
//                     {helpText}
//                 </Tooltip>
//             )}
//             <div className="w-100">
//                 {showFlags ? (
//                     <PhoneInput
//                         country={'us'}
//                         value={inputValue}
//                         onChange={handleInputChange}
//                         onBlur={handleInputBlur}
//                         inputProps={{
//                             name: name,
//                             required: required,
//                             placeholder: placeholder,
//                         }}
//                         inputStyle={{ width: '100%' }}
//                         enableSearch
//                         countryCodeEditable={false}
//                     />
//                 ) : (
//                     <Input
//                         type="text"
//                         name={name}
//                         id={id}
//                         placeholder={placeholder}
//                         value={inputValue}
//                         onChange={(e) => handleInputChange(e.target.value)}
//                         onBlur={handleInputBlur}
//                         maxLength={10}
//                         pattern="\d{10}"
//                         invalid={!!errors.required || !!errors.validation}
//                     />
//                 )}

//                 {errors.required && (
//                     <FormFeedback type="invalid" style={{ display: 'block' }}>
//                         {errors.required}
//                     </FormFeedback>
//                 )}
//                 {errors.validation && (
//                     <FormFeedback type="invalid" style={{ display: 'block' }}>
//                         {errors.validation}
//                     </FormFeedback>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default PhoneNumberInput;


import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import { Input, FormFeedback, Tooltip } from "reactstrap";

const PhoneNumberInput = ({
    label = "Phone Number",
    placeholder = "Enter your phone number",
    required = false,
    layout = "below",
    name = "phone",
    value = "",
    id = "phoneNumberInput",
    validateTrigger = false,
    onChange = () => {},
    onBlur = () => {},
    requiredErrorMessage = "This field is required.",
    validationErrorMessage = "Please enter a valid phone number.",
    showHelp = false,
    helpText = "Please enter your phone number, including country code.",
    showFlags = true,
}) => {
    const [inputValue, setInputValue] = useState(value);
    const [errors, setErrors] = useState({});
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        setInputValue(value); // Update inputValue when the value prop changes
    }, [value]);

    useEffect(() => {
        if (validateTrigger) {
            validateInput(inputValue);
        }
    }, [validateTrigger]);

    const validateInput = (value) => {
        const newErrors = {};
        const numericValue = value.replace(/\D/g, "");

        if (required && !value) {
            newErrors.required = requiredErrorMessage;
        } else if (!showFlags && numericValue.length !== 10) {
            newErrors.validation = "Phone number must be exactly 10 digits.";
        } else if (showFlags && numericValue.length < 10) {
            newErrors.validation = validationErrorMessage;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (value) => {
        setInputValue(value);
        validateInput(value);
        onChange(value);
    };

    const handleInputBlur = () => {
        validateInput(inputValue);
        onBlur();
    };

    return (
        <div className={layout === "inline" ? "d-flex align-items-center" : ""} style={{ marginBottom: '1rem' }}>
            {label && (
                <label htmlFor={id} className="d-flex align-items-center" style={{width: layout === "inline" ? "20%" : "100%" }}>
                    {label}
                    {required && <span className="text-danger mx-1">*</span>}
                    {showHelp && (
                        <span id="helpTooltip" className="px-2" style={{ cursor: 'pointer' }}>
                            <i className="ri-question-line" style={{ fontSize: '16px' }} />
                        </span>
                    )}
                </label>
            )}
            {showHelp && (
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target="helpTooltip"
                    toggle={() => setTooltipOpen(!tooltipOpen)}
                >
                    {helpText}
                </Tooltip>
            )}
            <div className="w-100" style={{ marginLeft: label ? undefined : "0" }}>
                {showFlags ? (
                    <PhoneInput
                        country={'us'}
                        value={inputValue}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        inputProps={{
                            name: name,
                            required: required,
                            placeholder: placeholder,
                        }}
                        inputStyle={{ width: '100%' }}
                        enableSearch
                        countryCodeEditable={false}
                    />
                ) : (
                    <Input
                        type="text"
                        name={name}
                        id={id}
                        placeholder={placeholder}
                        value={inputValue}
                        onChange={(e) => handleInputChange(e.target.value)}
                        onBlur={handleInputBlur}
                        maxLength={10}
                        pattern="\d{10}"
                        invalid={!!errors.required || !!errors.validation}
                    />
                )}

                {errors.required && (
                    <FormFeedback type="invalid" style={{ display: 'block' }}>
                        {errors.required}
                    </FormFeedback>
                )}
                {errors.validation && (
                    <FormFeedback type="invalid" style={{ display: 'block' }}>
                        {errors.validation}
                    </FormFeedback>
                )}
            </div>
        </div>
    );
};

export default PhoneNumberInput;
